import { render, staticRenderFns } from "./Lrtjz.vue?vue&type=template&id=2016a132&scoped=true&"
import script from "./Lrtjz.vue?vue&type=script&lang=js&"
export * from "./Lrtjz.vue?vue&type=script&lang=js&"
import style0 from "./Lrtjz.vue?vue&type=style&index=0&id=2016a132&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2016a132",
  null
  
)

export default component.exports